import { render, staticRenderFns } from "./simCards.vue?vue&type=template&id=994fd55a&"
import script from "./simCards.vue?vue&type=script&lang=js&"
export * from "./simCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports